import * as Types from '../../../generated/webapp_gql';

import { ProviderFragment } from './getMyProvidersQuery.generated';
import { gql } from 'graphql.macro';
import { ProviderFragmentDoc } from './getMyProvidersQuery.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type MatchedProviderFragment = (
  { __typename?: 'CoachNode' }
  & Pick<Types.CoachNode, 'matchAlgorithmVersion'>
  & { preferencesMatched?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'MemberFilterPreferenceNode' }
    & Pick<Types.MemberFilterPreferenceNode, 'name'>
    & { options?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'MemberFilterPreferenceOptionNode' }
      & Pick<Types.MemberFilterPreferenceOptionNode, 'name' | 'value'>
    )>>> }
  )>>> }
  & ProviderFragment
);

export type MatchedProvidersMutationVariables = Types.Exact<{
  careRecommendationUuid: Types.Scalars['UUID'];
  pagination?: Types.Maybe<Types.PaginationInput>;
  preferences: Types.MemberPreferencesInput;
  providerTypeOverride?: Types.Maybe<Types.Scalars['String']>;
}>;


export type MatchedProvidersMutation = (
  { __typename?: 'Mutation' }
  & { matchedProviders?: Types.Maybe<(
    { __typename?: 'MatchedProvidersMutation' }
    & Pick<Types.MatchedProvidersMutation, 'allowsFiltering'>
    & { providerMatchAttempt?: Types.Maybe<(
      { __typename?: 'ProviderMatchAttemptNode' }
      & Pick<Types.ProviderMatchAttemptNode, 'uuid'>
    )>, providersMatchedPreferences?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'CoachNode' }
      & MatchedProviderFragment
    )>>>, providersDidNotMatchPreferences?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'CoachNode' }
      & Pick<Types.CoachNode, 'uuid' | 'firstName' | 'lastName' | 'avatar' | 'sex' | 'officeHours' | 'providerType' | 'providerSchedulingType' | 'maximumMemberSlots' | 'bufferTime' | 'defaultVisitDuration' | 'lateCancellationThreshold' | 'languagePreferences' | 'country' | 'introduction' | 'providerSpecialties' | 'licensedStates' | 'city' | 'state' | 'zipCode' | 'goalInterests' | 'matchScore' | 'credentials' | 'therapistModalities' | 'matchAlgorithmVersion' | 'races' | 'providerNextAvailability'>
      & { preferencesMatched?: Types.Maybe<Array<Types.Maybe<(
        { __typename?: 'MemberFilterPreferenceNode' }
        & Pick<Types.MemberFilterPreferenceNode, 'name'>
        & { options?: Types.Maybe<Array<Types.Maybe<(
          { __typename?: 'MemberFilterPreferenceOptionNode' }
          & Pick<Types.MemberFilterPreferenceOptionNode, 'name' | 'value'>
        )>>> }
      )>>> }
    )>>> }
  )> }
);

export const MatchedProviderFragmentDoc = gql`
    fragment MatchedProvider on CoachNode {
  ...Provider
  matchAlgorithmVersion
  preferencesMatched(preferences: $preferences) {
    name
    options {
      name
      value
    }
  }
}
    ${ProviderFragmentDoc}`;
export const MatchedProvidersDocument = gql`
    mutation matchedProviders($careRecommendationUuid: UUID!, $pagination: PaginationInput, $preferences: MemberPreferencesInput!, $providerTypeOverride: String) {
  matchedProviders(
    careRecommendationUuid: $careRecommendationUuid
    pagination: $pagination
    preferences: $preferences
    providerTypeOverride: $providerTypeOverride
  ) {
    providerMatchAttempt {
      uuid
    }
    allowsFiltering
    providersMatchedPreferences {
      ...MatchedProvider
    }
    providersDidNotMatchPreferences {
      uuid
      firstName
      lastName
      avatar
      sex
      officeHours
      providerType
      providerSchedulingType
      maximumMemberSlots
      bufferTime
      defaultVisitDuration
      lateCancellationThreshold
      languagePreferences
      country
      introduction
      providerSpecialties
      licensedStates
      city
      state
      zipCode
      goalInterests
      matchScore
      credentials
      therapistModalities
      matchAlgorithmVersion
      races
      providerNextAvailability
      preferencesMatched(preferences: $preferences) {
        name
        options {
          name
          value
        }
      }
    }
  }
}
    ${MatchedProviderFragmentDoc}
${ProviderFragmentDoc}`;
export type MatchedProvidersMutationFn = ApolloReactCommon.MutationFunction<MatchedProvidersMutation, MatchedProvidersMutationVariables>;
export type MatchedProvidersComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MatchedProvidersMutation, MatchedProvidersMutationVariables>, 'mutation'>;

    export const MatchedProvidersComponent = (props: MatchedProvidersComponentProps) => (
      <ApolloReactComponents.Mutation<MatchedProvidersMutation, MatchedProvidersMutationVariables> mutation={MatchedProvidersDocument} {...props} />
    );
    
export type MatchedProvidersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MatchedProvidersMutation, MatchedProvidersMutationVariables>
    } & TChildProps;
export function withMatchedProviders<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MatchedProvidersMutation,
  MatchedProvidersMutationVariables,
  MatchedProvidersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MatchedProvidersMutation, MatchedProvidersMutationVariables, MatchedProvidersProps<TChildProps, TDataName>>(MatchedProvidersDocument, {
      alias: 'matchedProviders',
      ...operationOptions
    });
};

/**
 * __useMatchedProvidersMutation__
 *
 * To run a mutation, you first call `useMatchedProvidersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchedProvidersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchedProvidersMutation, { data, loading, error }] = useMatchedProvidersMutation({
 *   variables: {
 *      careRecommendationUuid: // value for 'careRecommendationUuid'
 *      pagination: // value for 'pagination'
 *      preferences: // value for 'preferences'
 *      providerTypeOverride: // value for 'providerTypeOverride'
 *   },
 * });
 */
export function useMatchedProvidersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MatchedProvidersMutation, MatchedProvidersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MatchedProvidersMutation, MatchedProvidersMutationVariables>(MatchedProvidersDocument, options);
      }
export type MatchedProvidersMutationHookResult = ReturnType<typeof useMatchedProvidersMutation>;
export type MatchedProvidersMutationResult = ApolloReactCommon.MutationResult<MatchedProvidersMutation>;
export type MatchedProvidersMutationOptions = ApolloReactCommon.BaseMutationOptions<MatchedProvidersMutation, MatchedProvidersMutationVariables>;